import { useEffect, useState } from "react";
import { useAppDispatch } from "../../reducers/store";
import { resetPassword, sendResetPassword } from "../../reducers/sessionSlice";
import { useNavigate } from "react-router-dom";
import qnetLogo from "../../assets/qnet-with-text-logo.svg";
import { LoginImageContainer } from "./image-container";

export function ResetPassword() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [token, setToken] = useState<string | null>(null);
    const [email, setEmail] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [password, setPassword] = useState<string>();
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);


    useEffect(() => {
        // Grab value after #recoveryToken=
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("recoveryToken");
        const email = urlParams.get("email");
        setToken(token);
        setEmail(email);
    }, []);

    const resetPasswordRequest = async () => {      
        if (token && email && password) {
            const result = await dispatch(resetPassword({ email, token, newPassword: password }));

            if (result.type.endsWith('/fulfilled')) {
                localStorage.removeItem("auth_token");
                localStorage.removeItem("selected_supplier");
                localStorage.removeItem("selected_producting_facilities");
                navigate("/login");
            }
        }
    }

    const checkPassword = (e: { target: { value: string; }; }) => {
        if(e.target.value == password){
            setIsButtonDisabled(false);
            setErrorMessage(null);
        } else{
            setIsButtonDisabled(true);
            setErrorMessage("Your passwords must match");
        }
      }

    return (
        // <div className="flex flex-col items-center justify-center h-screen">
        //     <h1 className="text-2xl font-bold">Reset Password</h1>
        //     <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        //     <button onClick={resetPasswordRequest}>Reset Password</button>
        // </div>
        <div className="flex h-screen w-screen items-center justify-center gap-x-[28px] pb-[5rem] pl-[2rem] pr-[2rem] pt-[5rem] max-[680px]:gap-x-0 max-[680px]:pb-[15rem] max-[680px]:pt-[0rem]">
            <div className="max-w-[800px] flex-grow max-[1200px]:hidden">
                <LoginImageContainer />
            </div>
            <div className="flex aspect-square w-full max-[768px]:w-[100%]">
                <div className="flex w-full flex-col max-[768px]:max-w-[100%] justify-center">
                    <div className="flex items-center justify-start pt-[2vh]"></div>
                    <div className="flex max-h-[500px] w-full flex-1 flex-col items-baseline justify-center pl-8 pr-8">
                    <img
                        className="mb-4 h-[100%] max-h-[85px]"
                        src={qnetLogo}
                        alt="QNET Logo"
                    />
                    <div className="flex w-[100%] items-center justify-start max-[768px]:justify-center">
                        <span className="text-[32px] text-[black]">
                        Welcome to <b>Qnet™</b> 👋
                        </span>
                    </div>

                    <div className="flex w-[100%] items-center justify-start max-[768px]:justify-center">
                        <span className="text-[14px] text-[#333333]">
                        {"Enter a new password"}
                        </span>
                    </div>

                    (
                        <div className="flex w-[100%] flex-col pt-[16px]">
                            <div className="label">
                                <span className="label-text text-[#333333]">New Password*</span>
                            </div>
                            <div className="flex items-center">
                                <input
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                                placeholder="New Password"
                                className="input input-bordered w-full border-[grey] bg-[white] text-[black]"
                                />
                            </div>
                        </div>
                    )
                    (
                        <div className="flex w-[100%] flex-col pt-[16px]">
                            <div className="label">
                                <span className="label-text text-[#333333]">Confirm New Password*</span>
                            </div>
                            <div className="flex items-center">
                                <input
                                onChange={(e) => checkPassword(e)}
                                type="password"
                                placeholder="Confirm New Password"
                                className="input input-bordered w-full border-[grey] bg-[white] text-[black]"
                                />
                            </div>
                        </div>
                        {errorMessage && 
                            <p className="text-tqsRed text-xs font-semibold mt-1 ps-3">{errorMessage}</p>
                        }
                    )
                    <div className="flex w-[100%] items-center justify-start pt-[20px]">
                        <button
                        disabled={
                            isButtonDisabled
                        }
                        onClick={resetPasswordRequest}
                        className="btn w-full border-none bg-[#fedd00] text-black hover:bg-[#fedd00] disabled:bg-[#fedd00] disabled:text-[black] disabled:opacity-60"
                        >
                        Submit
                        </button>
                    </div>
                    </div>

                    <div className="border[grey] border-b-[1px] pt-[50px]"></div>

                    <div
                        onClick={() => navigate("/login")}
                        className="flex items-center justify-center pb-[5vh] pt-[14px] text-[#fedd00] hover:cursor-pointer"
                    >
                        <span>Return to login page</span>
                    </div>
                
                </div>
            </div>
        </div>
    )
}